/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

module.exports = {
  //设置登录后的信息
  SET_LOGININFO(state, loginInfo) {
    state.loginInfo = loginInfo;
  }

}



// WEBPACK FOOTER //
// ./src/appBackend/vuex/mutation/login.js